import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'light',
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
});

export default darkTheme;